export const REPAIR_MACHINE_TYPE_OPTIONS = [
    { label: 'Máquina de Café', value: 'coffee' },
    { label: 'Máquina de Snack', value: 'snack' }
];

export const GENERAL_FAILURE_CATEGORY_OPTIONS = [
    { label: 'Card payment systems', value: 'Card payment systems' },
    { label: 'Bill payment systems', value: 'Bill payment systems' },
    { label: 'Coin payment systems', value: 'Coin payment systems' },
    { label: 'Compressors', value: 'Compressors' },
    { label: 'Locks', value: 'Locks' },
    { label: 'CPU cards', value: 'CPU cards' },
    { label: 'Telemetry', value: 'Telemetry' },
    { label: 'Drop sensors', value: 'Drop sensors' },
    { label: 'Other', value: 'Other' }
];

export const FAILURE_GROUPS_BY_MACHINE_TYPE = {
    coffee: {
        Mecánica: [
            'Molino',
            'Grupo de café',
            'Sistema de vasos',
            'Fallo en sistema de azúcar',
            'Fallo en motores',
            'Falta de Contenedores',
            'Cerraduras',
            'Puertas'
        ],
        Hídricas: [
            'No dispensa agua',
            'Baja presión de agua',
            'Fuga de agua interna',
            'Bomba de agua defectuosa',
            'Electroválvulas dañadas',
            'Mangueras',
            'Conexiones Externas',
            'Conexiones Internas'
        ],
        Temperatura: [
            'No calienta el agua',
            'Temperatura insuficiente',
            'Sobrecalentamiento',
            'Resistencia dañada',
            'Daño en Caldera'
        ],
        'Eléctrica / Electrónica': [
            'Máquina no enciende',
            'Tarjeta electrónica defectuosa',
            'Error en display',
            'Sensores defectuosos',
            'Fuente de poder dañada',
            'Fusible',
            'Interruptor de Puerta',
            'Problemas de teclado'
        ],
        'Sistema de Pago': [
            'POS TDC no funciona',
            'Crédito pegado',
            'Software Incorrecto TDC',
            'Yappy no procesa',
            'No acepta monedas',
            'No acepta billetes',
            'No devuelve dinero',
            'Sistema Zip',
            'Validador'
        ],
        'Configuración / Dosificación': [
            'Dosificación de café incorrecta',
            'Dosificación de agua incorrecta',
            'Dosificación de avena incorrecta',
            'Dosificación de leche incorrecta',
            'Dosificación de chocolate incorrecta',
            'Dosificación de chai incorrecta',
            'Dosificación de azúcar incorrecta',
            'Bebida sale muy aguada',
            'Bebida sale muy concentrada',
            'Receta desbalanceada',
            'Volumen de bebida incorrecto',
            'Parámetros de pulsos mal calibrados',
            'Precios mal configurados',
            'Recetas mal programadas'
        ],
        Comunicación: [
            'Máquina no transmite datos',
            'Telemetría desconectada/ cableado',
            'Datos incorrectos en sistema',
            'Falta de Señal',
            'Sim Car no funciona',
            'Telefono dañado',
            'Cargador dañado',
            'Modulo bluetooth',
            'Configuracion incorrecta',
            'Telemetro dañado'
        ],
        'Operativa (Campo)': [
            'Falta de producto',
            'Producto mal cargado',
            'Limpieza deficiente',
            'No se realizó fumigación',
            'Precio incorrecto'
        ],
        'Higiene / Contaminación': [
            'Presencia de cucarachas',
            'Huevos en sistema de azúcar',
            'Contaminación en grupo de café',
            'Sistema de vasos sucio'
        ]
    },
    snack: {
        Mecánica: [
            'Motor de espiral no gira',
            'Espiral mal alineado',
            'Producto atascado',
            'Sensor de caída defectuoso',
            'Bandejas trabadas',
            'Gabetas',
            'Puertas',
            'Cerraduras'
        ],
        Configuración: [
            'Espiral desalineado (no se realizó Can Alineame)',
            'Selección incorrecta',
            'Recept de Motores',
            'Recept de Averias',
            'Gestion celda OFF'
        ],
        'Sistemas de Pago': [
            'POS TDC no funciona',
            'Crédito pegado',
            'Software Incorrecto TDC',
            'Yappy no procesa',
            'No acepta monedas',
            'No acepta billetes',
            'No devuelve dinero',
            'Sistema Zip',
            'Validador',
            'Configuracion de sistema de pago',
            'Coneccion 110v POS'
        ],
        Eléctrica: [
            'Máquina apagada',
            'Display dañado',
            'Tarjeta electrónica defectuosa',
            'Fuente de poder dañada',
            'Problemas de teclado',
            'Regulador de voltage',
            'Cableados',
            'Fusibles',
            'Porta fusibles',
            'Cambio de lamparas'
        ],
        Comunicación: [
            'No transmite ventas',
            'Máquina offline en sistema',
            'Máquina no transmite datos',
            'Telemetría desconectada/ cableado',
            'Datos incorrectos en sistema',
            'Falta de Señal',
            'Sim Car no funciona',
            'Telefono dañado',
            'Cargador dañado',
            'Modulo bluetooth',
            'Configuracion incorrecta',
            'Telemetro dañado'
        ],
        'Sistema de Frío': [
            'Problemas de Compresor',
            'Sonda de temperatura',
            'Relay de Arranque',
            'Star kit',
            'Ventilador de compresor',
            'Abanicos internos',
            'Desague tapado',
            'Rejilla tapada',
            'Cableado de compresor',
            'Cableado de motores'
        ]
    }
};

export const GENERAL_FAILURE_TYPE_OPTION = { label: 'General', value: 'General' };
export const OTHER_FAILURE_TYPE_OPTION = { label: 'Other', value: 'Other' };

export const FAILURE_CATEGORY_PRIORITIES = {
    'Card payment systems': 9,
    'Bill payment systems': 9,
    'Coin payment systems': 7,
    Compressors: 10,
    Locks: 3,
    'CPU cards': 10,
    Telemetry: 5,
    'Drop sensors': 8,
    Molino: 9,
    'Grupo de café': 9,
    'Sistema de vasos': 8,
    'Fallo en sistema de azúcar': 7,
    'Fallo en motores': 9,
    'Falta de Contenedores': 6,
    Cerraduras: 3,
    Puertas: 4,
    'No dispensa agua': 10,
    'Baja presión de agua': 8,
    'Fuga de agua interna': 10,
    'Bomba de agua defectuosa': 10,
    'Electroválvulas dañadas': 9,
    Mangueras: 7,
    'Conexiones Externas': 6,
    'Conexiones Internas': 8,
    'No calienta el agua': 10,
    'Temperatura insuficiente': 8,
    Sobrecalentamiento: 10,
    'Resistencia dañada': 9,
    'Daño en Caldera': 10,
    'Máquina no enciende': 10,
    'Máquina apagada': 10,
    'Tarjeta electrónica defectuosa': 10,
    'Error en display': 5,
    'Display dañado': 5,
    'Sensores defectuosos': 8,
    'Fuente de poder dañada': 10,
    Fusible: 8,
    Fusibles: 8,
    'Interruptor de Puerta': 6,
    'Problemas de teclado': 7,
    'POS TDC no funciona': 9,
    'Crédito pegado': 9,
    'Software Incorrecto TDC': 8,
    'Yappy no procesa': 8,
    'No acepta monedas': 7,
    'No acepta billetes': 9,
    'No devuelve dinero': 10,
    'Sistema Zip': 7,
    Validador: 9,
    'Dosificación de café incorrecta': 8,
    'Dosificación de agua incorrecta': 8,
    'Dosificación de avena incorrecta': 6,
    'Dosificación de leche incorrecta': 7,
    'Dosificación de chocolate incorrecta': 6,
    'Dosificación de chai incorrecta': 5,
    'Dosificación de azúcar incorrecta': 6,
    'Bebida sale muy aguada': 7,
    'Bebida sale muy concentrada': 7,
    'Receta desbalanceada': 7,
    'Volumen de bebida incorrecto': 8,
    'Parámetros de pulsos mal calibrados': 8,
    'Precios mal configurados': 8,
    'Recetas mal programadas': 8,
    'Máquina no transmite datos': 6,
    'No transmite ventas': 7,
    'Máquina offline en sistema': 6,
    'Telemetría desconectada/ cableado': 5,
    'Datos incorrectos en sistema': 5,
    'Falta de Señal': 4,
    'Sim Car no funciona': 5,
    'Telefono dañado': 4,
    'Cargador dañado': 3,
    'Modulo bluetooth': 3,
    'Configuracion incorrecta': 5,
    'Telemetro dañado': 6,
    'Falta de producto': 10,
    'Producto mal cargado': 8,
    'Limpieza deficiente': 8,
    'No se realizó fumigación': 10,
    'Precio incorrecto': 7,
    'Presencia de cucarachas': 10,
    'Huevos en sistema de azúcar': 10,
    'Contaminación en grupo de café': 10,
    'Sistema de vasos sucio': 8,
    'Motor de espiral no gira': 9,
    'Espiral mal alineado': 7,
    'Producto atascado': 8,
    'Sensor de caída defectuoso': 8,
    'Bandejas trabadas': 7,
    Gabetas: 5,
    'Espiral desalineado (no se realizó Can Alineame)': 8,
    'Selección incorrecta': 8,
    'Recept de Motores': 8,
    'Recept de Averias': 7,
    'Gestion celda OFF': 7,
    'Configuracion de sistema de pago': 8,
    'Coneccion 110v POS': 8,
    'Regulador de voltage': 8,
    Cableados: 8,
    'Porta fusibles': 7,
    'Cambio de lamparas': 2,
    'Problemas de Compresor': 10,
    'Sonda de temperatura': 9,
    'Relay de Arranque': 9,
    'Star kit': 9,
    'Ventilador de compresor': 8,
    'Abanicos internos': 8,
    'Desague tapado': 7,
    'Rejilla tapada': 6,
    'Cableado de compresor': 9,
    'Cableado de motores': 8
};

const normalizeText = (value) =>
    String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();

const PRIORITY_BY_NORMALIZED_CATEGORY = Object.entries(FAILURE_CATEGORY_PRIORITIES).reduce((map, [category, priority]) => {
    map[normalizeText(category)] = priority;
    return map;
}, {});

export const getFailureCategoryPriority = (category) => {
    const normalized = normalizeText(category);
    if (!normalized) return null;
    const priority = PRIORITY_BY_NORMALIZED_CATEGORY[normalized];
    return Number.isFinite(priority) ? priority : null;
};

export const inferRepairMachineType = (value) => {
    const normalized = normalizeText(value);
    if (!normalized) return '';
    if (normalized.includes('cafe') || normalized.includes('coffee')) return 'coffee';
    if (
        normalized.includes('snack') ||
        normalized.includes('combo') ||
        normalized.includes('drink') ||
        normalized.includes('soda')
    ) {
        return 'snack';
    }
    return '';
};

export const getFailureTypeOptionsForMachineType = (repairMachineType) =>
    [
        GENERAL_FAILURE_TYPE_OPTION,
        ...Object.keys(FAILURE_GROUPS_BY_MACHINE_TYPE[repairMachineType] || {}).map((failureType) => ({
            label: failureType,
            value: failureType
        })),
        OTHER_FAILURE_TYPE_OPTION
    ];

export const getAllFailureTypeOptions = () =>
    [
        GENERAL_FAILURE_TYPE_OPTION,
        ...Array.from(
            new Set(
                Object.values(FAILURE_GROUPS_BY_MACHINE_TYPE).flatMap((groups) =>
                    Object.keys(groups)
                )
            )
        ).map((failureType) => ({
            label: failureType,
            value: failureType
        })),
        OTHER_FAILURE_TYPE_OPTION
    ];

export const getFailureCategoryOptions = (repairMachineType, failureType) => {
    if (failureType === 'General') {
        return GENERAL_FAILURE_CATEGORY_OPTIONS;
    }
    if (failureType === 'Other') {
        return GENERAL_FAILURE_CATEGORY_OPTIONS.filter((option) => option.value === 'Other');
    }
    const specificCategories = repairMachineType
        ? FAILURE_GROUPS_BY_MACHINE_TYPE[repairMachineType]?.[failureType] || []
        : Object.values(FAILURE_GROUPS_BY_MACHINE_TYPE).flatMap((groups) => groups[failureType] || []);
    return Array.from(new Set(specificCategories)).map((category) => ({
        label: category,
        value: category
    }));
};
